import React from 'react';
import '../App.css';
import Top_Banner_All from '../assests/Top_Banner_All.jpg';
import Pricing_Start from '../assests/Pricing_Start.jpg';
import Pricing_Mid from '../assests/Pricing_Mid.jpg';
import Pricing_Adv from '../assests/Pricing_Adv.jpg';
import Pricing_Adv1 from '../assests/Hero_Home_1.jpg';
import Pricing_Adv2 from '../assests/Hero_Home_Prime.jpg';

const Pricing = () => {

  return (
    <section className="pricing-section">

      {/* First Child */}
      <div className="header-image-container">
        <header className={`pricing-header`}>
        <img src={Top_Banner_All} alt="Pricing Background" className="pricing-img" />
        <h1 className="pricing-title">Pricing</h1>
        </header>
      </div>

      {/* Second Child */}
      <section className="pricing-details">
        <div className="pricing-content">
          <div className="pricing-text">
            <h2>MEMBERSHIP PRICING CHART</h2>
            <h1>Exclusive Pricing Plan</h1>
            <p>Vortex gym membership offers flexible options. Choose the plan that fits your fitness goals and schedule.</p>
          </div>
        </div>
        <div>
          <div className="pricing-cards">
            <div className="pricing-card">
              <div className="card-image">
                <img src={Pricing_Start} alt="Plan 1" />
              </div>
              <div className="card-text">
                <h2>Monthly</h2>
                <br />
                <h3>₹ 3000 </h3>
                <br />
                <p>Sauna Bath</p>
                <br />
                <p>Weight Loss</p>
                <br />
                <p>Shower Room</p>
              </div>
            </div>
            <div className="pricing-card">
              <div className="card-image">
                <img src={Pricing_Mid} alt="Plan 2" />
              </div>
              <div className="card-text">
                <h2>3 Months / Quaterly</h2>
                <br />
                <h3>₹ 5500 </h3>
                <br />
                <p>Sauna Bath</p>
                <br />
                <p>Weight Loss</p>
                <br />
                <p>Shower Room</p>
              </div>
            </div>
            <div className="pricing-card">
              <div className="card-image">
                <img src={Pricing_Adv} alt="Plan 3" />
              </div>
              <div className="card-text">
                <h2>6 Months / Semi-Annual</h2>
                <br />
                <h3>₹ 8500 </h3>
                <br />
                <p>Sauna Bath</p>
                <br />
                <p>Weight Loss</p>
                <br />
                <p>Shower Room</p>
              </div>
            </div>
            <div className="pricing-card">
              <div className="card-image">
                <img src={Pricing_Adv1} alt="Plan 4" />
              </div>
              <div className="card-text">
                <h2>9 Months / Third Trimester + 1 Month Free</h2>
                <br />
                <h3>₹ 10500 </h3>
                <br />
                <p>Sauna Bath</p>
                <br />
                <p>Weight Loss</p>
                <br />
                <p>Shower Room</p>
              </div>
            </div>
            <div className="pricing-card">
              <div className="card-image">
                <img src={Pricing_Adv2} alt="Plan 5" />
              </div>
              <div className="card-text">
                <h2>12 Months / Annual + 2 Months Free</h2>
                <br />
                <h3>₹ 12500 </h3>
                <br />
                <p>Sauna Bath</p>
                <br />
                <p>Weight Loss</p>
                <br />
                <p>Shower Room</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  )
}

export default Pricing;
